import { useEffect, useRef, useState } from "react";

import styles from "./Collapsible.module.css";

export default function Collapsible({ onClick = () => { }, children }) {
  const [shown, setShown] = useState(false);
  const contentRef = useRef(null);

  const handleToggle = () => {
    onClick();  // call parent function 

    const newShownState = !shown;
    setShown(newShownState);
  };

  useEffect(() => {
    if (shown && contentRef.current) {
      contentRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [shown]);

  return (
    <div id="collapsible-container">
      <button className={styles.buttonContainer} onClick={handleToggle} aria-expanded={shown} aria-controls="collapsible-content">
        <p className={styles.actionText}>{shown ? "show less" : "show more"}</p>
        {/* <p style={{ marginLeft: 2 }}> {shown ? <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon lucide lucide-chevron-up-icon lucide-chevron-up" aria-hidden="true"><path d="m18 15-6-6-6 6" /></svg> : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon lucide lucide-chevron-right-icon lucide-chevron-right" aria-hidden="true"><path d="m9 18 6-6-6-6" /></svg>}</p> */}
      </button>

      <div id="collapsible-content" ref={contentRef} hidden={!shown} className={[styles.content, shown ? styles.fadeIn : styles.fadeOut].join(" ")}>{children}</div>
    </div>
  );
}